import { COLOR1, COLOR2, COLOR4, RADIO_COLOR } from '../../constants';

export const BusinessAditionalInfoStyles = {
  business_info_stepper: {
    width: '100%',
    margin: '37px 30px 24px 50px',
    '@media (max-width:960px)': {
      margin: '37px 50px 30px 50px',
    },
    '@media (max-width:650px)': {
      margin: '25px 25px 0px 25px',
    },
  },

  inputNew_Style: {
    marginBottom: '10px !important',
    fontStyle: 'normal !important',
    fontWeight: '700 !important',
    fontSize: '14px !important',
    lineHeight: '18px !important',
    color: '#444444 !important',
  },

  third_screen_img: {
    '@media (max-width:960px)': {
      display: 'flex',
      justifyContent: 'center',
      maxWidth: 'none',
      marginTop: 0,
    },
    '@media (max-width:650px)': {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '20px',
    },
  },

  error_message: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    position: 'relative',
    top: '3px',
    display: 'block',
  },

  business_info_heading: {
    textAlign: 'left',
    lineHeight: '28px',
    width: 'fit-content',
    font: 'normal normal bold 20px/23px TTNormsProBold',
    letterSpacing: '0.14px',
    color: COLOR1,
    opacity: 1,
    marginBottom: '30px',
    paddingLeft: '16px',
    '@media (min-width:960px)': {
      marginBottom: '20px',
      paddingLeft: '16px',
    },
    '@media (max-width:960px)': {
      marginBottom: '10px',
      paddingLeft: '16px',
    },
    '@media (max-width:600px)': {
      font: 'normal normal 700 22px/32px Arial',
      letterSpacing: '0.11px',
      margin: 0,
      marginBottom: '20px',
      paddingLeft: 0,
    },
  },

  field_padding: {
    padding: '16px',
    '@media (max-width:600px)': {
      padding: '10px 0',
    },
  },

  business_info_container: {
    '@media (min-width:600px)': {
      mbackground: '#FFFFFF',
      border: '1px solid #D0D0D0',
      boxShadow: '0px 4px 4px rgb(0 0 0 / 21%)',
      borderRadius: '6px',
      padding: '25px 14px 33px',
      opacity: 1,
    },
  },

  imageContainer: {
    maxWidth: '320px',
    width: '100%',
    '@media (min-width:960px)': {
      height: '338px',
    },
  },

  personal_button_container: {
    '@media (max-width:600px)': {
      justifyContent: 'center',
    },
  },

  button_grid: {
    '@media (min-width:960px)': {
      paddingTop: '30px',
      paddingBottom: '40px',
    },
  },

  compliance_button_container: {
    '@media (max-width:650px)': {
      justifyContent: 'center',
      display: 'flex',
    },
  },

  creditContainer_padding: {
    '@media (min-width:600px)': {
      padding: '0 16px',
    },
  },

  back_button: {
    border: `1px solid ${RADIO_COLOR}`,
    borderRadius: '25px',
    opacity: 1,
    width: '147px',
    height: '45px',
    margin: '0px 15px 0px 0px',
    font: 'normal normal bold 16px/18px Arial',
    letterSpacing: '1.01px',
    color: `${RADIO_COLOR} !important`,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: COLOR4,
    },
    '@media (max-width:650px)': {
      width: '48%',
      maxWidth: '160px',
    },
    '@media (max-width:360px)': {
      width: '45%',
    },
    '@media (max-width:300px)': {
      font: 'normal normal bold 14px Arial',
    },
  },
};
